/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import { cloneDeep, isArray } from 'lodash';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { usePOMGroupState } from './PomGroupContext';

import { checkArray, showBigImage, hideImage, shortenandHoverString } from '../../../../../Components/helper';
import noImage from '../../../../../assets/images/no-image.png';
import CustomTooltip from '../../../../../Components/Tooltip/CustomTooltip';

function TableView() {
  const { t } = useTranslation('common');
  const deleteButton = 'SPEC_TEMP_LIBRARY.DELETE';
  const { pomGroupState, setPomGroupState, handleCheckPOMList, handleCheckAll, isallChecked } = usePOMGroupState();
  const handleSingleDelete = (id) => {
    const pomData = cloneDeep(pomGroupState?.pomTableData);

    const updatedItems = pomData.filter((item) => item._id !== id);
    setPomGroupState((prev) => ({
      ...prev,
      pomTableData: updatedItems,
    }));
  };

  const forImage = (item) => {
    if (item?.annotatedImage && item?.annotatedImage !== '') {
      return item.annotatedImageUrl || item.annotatedImage;
    }
    if (!item.image || item?.image?.includes(' ')) {
      return noImage;
    }
    return item?.imageUrl || item?.image;
  };

  const renderCardList = () => {
    return pomGroupState?.pomTableData?.map((item, index) => (
      <Col key={item?.code} lg={3}>
        <div className="pom-item">
          <div className="pom-card-header">
            <p className="text-bold mb-0">{item?.code}</p>
            <div className="d-flex align-items-center">
              <div className="common-checkbox">
                <input
                  onChange={(e) => handleCheckPOMList(e.target.checked, item._id)}
                  checked={pomGroupState?.selectedPOM?.includes(item._id)}
                  name={`check_${index}`}
                  id={`check_${index}`}
                  type="checkbox"
                />
                <label htmlFor={`check_${index}`} className="chklabel" />
              </div>
              <CustomTooltip tooltipText={t('COMMON_LABEL.DELETE')}>
                <button
                  type="button"
                  className="btn d-inline-flex p-0 ml-16"
                  onClick={() => {
                    handleSingleDelete(item._id);
                  }}
                  aria-label={t(deleteButton)}
                >
                  <i className="icon-Delete f-24" />
                </button>
              </CustomTooltip>
            </div>
          </div>
          <div className="pom-card-body">
            <div className="description">
              <p> {shortenandHoverString(item?.description, 40)}</p>
            </div>
            <div className="image">
              <img alt="poster" src={forImage(item)} />
            </div>
          </div>
        </div>
      </Col>
    ));
  };

  return (
    <Container fluid>
      {pomGroupState?.tableView ? (
        <div className="table-responsive">
          <table className="mt-24 table common-custom-table">
            <thead>
              <tr>
                <th className="w-50px">
                  <div className="common-checkbox margin-auto">
                    <input type="checkbox" name="check_all_symbol" id="check_all_pom" onChange={(e) => handleCheckAll(e)} checked={isallChecked} />
                    <label htmlFor="check_all_pom" className="chklabel" />
                  </div>
                </th>
                <th className="w-100px text-left">{t('SPEC_TEMP_LIBRARY.IMAGE')}</th>
                <th className="w-400px">{t('SPEC_TEMP_LIBRARY.POM_CODE')}</th>
                <th className="w-500px"> {t('SPEC_TEMP_LIBRARY.POM_DESC')}</th>
                <th className="w-50px" />
              </tr>
            </thead>
            <tbody>
              {checkArray(pomGroupState?.pomTableData) ? (
                pomGroupState?.pomTableData.map((eleItem, i) => {
                  return (
                    <tr key={eleItem._id}>
                      <td>
                        <div className="common-checkbox margin-auto">
                          <input
                            type="checkbox"
                            name={`pom_${i}`}
                            id={`pom_${i}`}
                            checked={pomGroupState?.selectedPOM?.includes(eleItem._id)}
                            onChange={(e) => handleCheckPOMList(e.target.checked, eleItem._id)}
                          />
                          <label htmlFor={`pom_${i}`} className="chklabel" />
                        </div>
                      </td>
                      <td className="text-left">
                        <div className="image-small image-detail hover-right">
                          <figure onMouseOver={(e) => showBigImage(e)} onMouseLeave={() => hideImage()} className="m-0">
                            <div className="">
                              <img width="48" alt="product img" src={forImage(eleItem)} />
                            </div>
                          </figure>
                        </div>
                      </td>

                      <td>{eleItem?.code}</td>

                      <td> {shortenandHoverString(eleItem?.description, 85)}</td>

                      <td>
                        {' '}
                        <CustomTooltip tooltipText={t('COMMON_LABEL.DELETE')}>
                          <button
                            type="button"
                            className="btn p-0"
                            onClick={() => {
                              handleSingleDelete(eleItem._id);
                            }}
                            aria-label={t(deleteButton)}
                          >
                            <i className="icon-Delete f-20" />
                          </button>
                        </CustomTooltip>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={5}>
                    <p className="text-center m-0">{t('POM_GROUP.No_POM_ENTRY')}</p>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      ) : (
        <>
          {/* <div className="pom-library-cards">{renderCardList()}</div> */}
          <Row className="mt-24">{renderCardList()}</Row>
          {!isArray(pomGroupState?.pomTableData) ||
            (pomGroupState?.pomTableData.length === 0 && (
              <Row>
                <Col md="12">
                  <p className="mt-4 justify-content-center align-item-center d-flex">{t('POM_GROUP.No_POM_ENTRY')}</p>
                </Col>
              </Row>
            ))}
        </>
      )}
    </Container>
  );
}

export default TableView;
